import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PushNotificationService } from './core/notifications/push-notification.service';
import { Store } from '@ngrx/store';
import { SocketActions } from './state/socket/socket.actions';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { I18nService } from './core/i18n/i18n.service';
import { selectCurrentCompany } from './state/auth/auth.selectors';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly pushNotificationSvc = inject(PushNotificationService);
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);
  private readonly i18n = inject(I18nService);

  private readonly currentCompany =
    this.store.selectSignal(selectCurrentCompany);

  companyLanguage = this.currentCompany()?.language;

  ngOnInit(): void {
    if (this.companyLanguage) {
      this.i18n.setLanguage(this.companyLanguage);
    } else {
      this.i18n.setLanguageFromBrowser();
    }

    this.pushNotificationSvc.listenToClicks();
    this.store.dispatch(SocketActions.connect());

    // Cuando vuelve la conexión a internet, reconectar el socket
    fromEvent(window, 'online')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        console.log('Back online — reconnecting socket');
        this.store.dispatch(SocketActions.connect());
      });

    // Cuando cambia la visibilidad de la ventana, reconectar el socket
    fromEvent(document, 'visibilitychange')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (document.visibilityState === 'visible') {
          console.log('App visible again — reconnecting socket');
          this.store.dispatch(SocketActions.connect());
        }
      });
  }
}
